// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.addy-info {
  padding: 2px 15px;
  border-bottom: 1px solid #d4e4ff;
  border-top: 1px solid #d4e4ff;
  background-color: #eaf2ff;
}
div.addy-info .header {
  font-weight: 600;
  padding: 0px 0px;
  color: #4b58a6;
}
`, "",{"version":3,"sources":["webpack://./src/app/screening-module/components/excludable-records-dialog/excludable-records-dialog.component.less"],"names":[],"mappings":"AACA;EACI,iBAAA;EACA,gCAAA;EACA,6BAAA;EACA,yBAAA;AAAJ;AAJA;EAMQ,gBAAA;EACA,gBAAA;EACA,cAAA;AACR","sourcesContent":["@import (reference) url('../../../../assets/ngb-modals.less');\ndiv.addy-info{\n    padding: 2px 15px;\n    border-bottom: 1px solid #d4e4ff;\n    border-top: 1px solid #d4e4ff;\n    background-color: #eaf2ff;\n    .header{\n        font-weight: 600;\n        padding: 0px 0px;\n        color: #4b58a6;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
